var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1460,
    height: 1080,
    viewBox: "0 0 1460 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_90)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_103_90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1107.32,
    cy: 723.315,
    r: 553.777,
    transform: "rotate(-113.832 1107.32 723.315)",
    fill: "url(#paint0_linear_103_90)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_103_90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.315,
    cy: 698.315,
    r: 553.777,
    transform: "rotate(-113.832 425.315 698.315)",
    fill: "url(#paint1_linear_103_90)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_103_90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 354.315,
    cy: 28.3154,
    r: 553.777,
    transform: "rotate(-113.832 354.315 28.3154)",
    fill: "url(#paint2_linear_103_90)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_103_90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 941.315,
    cy: 47.3154,
    r: 553.777,
    transform: "rotate(-113.832 941.315 47.3154)",
    fill: "url(#paint3_linear_103_90)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_103_90",
    x: 353.399,
    y: -30.6007,
    width: 1507.83,
    height: 1507.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_103_90"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_103_90",
    x: -328.601,
    y: -55.6007,
    width: 1507.83,
    height: 1507.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_103_90"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_103_90",
    x: -399.601,
    y: -725.601,
    width: 1507.83,
    height: 1507.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_103_90"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_103_90",
    x: 187.399,
    y: -706.601,
    width: 1507.83,
    height: 1507.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_103_90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_90",
    x1: 1107.32,
    y1: 169.538,
    x2: 1107.32,
    y2: 1277.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2640FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_90",
    x1: 425.315,
    y1: 144.538,
    x2: 425.315,
    y2: 1252.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2640FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_90",
    x1: 354.315,
    y1: -525.462,
    x2: 354.315,
    y2: 582.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2640FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_90",
    x1: 941.315,
    y1: -506.462,
    x2: 941.315,
    y2: 601.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2640FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1460,
    height: 1080,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.ee16d2d8b6c3af365fa382e060a0675d.svg";
export { ForwardRef as ReactComponent };